import { Link } from 'react-router-dom';
import { policyCopy } from '../../data/policies';
import { legalLinks } from '../../data/legal';
import { shopLabels } from '../../data/shopLabels';
import { Drawer } from '../shared/Drawer';
import { Spinner } from '../../ui/Spinner';
import { btnPrimaryLg } from '../../ui/styles';
import { useBooking } from './useBooking';
import { BookingForm, BOOKING_FORM_ID } from './BookingForm';
import { BookingDone } from './BookingDone';

/** De afsprakenlade: aanvragen, en daarna de bevestiging met het thuisprotocol. */
export function BookingDrawer() {
  const b = useBooking();
  return <Drawer open={b.open} onClose={b.close} title={b.done ? 'Aanvraag verstuurd' : 'Afspraak aanvragen'} footer={b.done ? undefined : <div data-id="element-8409" data-mp="1z3jqi7lt4nzd">
            <button type="submit" form={BOOKING_FORM_ID} disabled={!b.canSubmit || b.submitting} className={`${btnPrimaryLg} w-full ${b.submitting ? 'disabled:cursor-wait' : ''}`} data-id="element-8410" data-mp="1z3a22ogeuovs">
              {b.submitting ? <>
                  <Spinner data-id="element-8411" data-mp="1xzh3txrxxy1s" />
                  Aanvraag wordt verstuurd…
                </> : b.canSubmit ? 'Aanvraag versturen' : b.signedIn ? 'Kies een dag en tijd' :
      // Kort genoeg voor één regel in de smalste lade (320px); welke velden ontbreken staat in het formulier.
      'Kies dag en tijd'}
            </button>
            {/* Annuleringsvoorwaarde vóór het versturen, niet pas in de bevestiging. */}
            <p className="mt-2 text-center text-[13px] leading-relaxed text-muted" data-id="element-8412" data-mp="11a9j2rz5bsyx">
              {policyCopy.cancel}; daarna breng ik de behandeling in rekening.{' '}
              <Link to={legalLinks.terms} target="_blank" rel="noreferrer" className="underline underline-offset-2 hover:text-ink" data-id="element-8413" data-mp="2vmg5yo1ejy72">
                Voorwaarden<span className="sr-only" data-id="element-8414" data-mp="2zni5l5z8ec9k"> {shopLabels.newTab}</span>
              </Link>
            </p>
          </div>} data-id="element-8408" data-mp="16mpgqksdchcm">
      {b.done ? <BookingDone b={b} data-id="element-8415" data-mp="7g98tt6bt66m" /> : <BookingForm b={b} data-id="element-8416" data-mp="7fzi23dgiuzv" />}
    </Drawer>;
}